(() => {
  if (window.ninemooPhotoProtection) return;
  window.ninemooPhotoProtection = true;
  const isPhoto = event => {
    const path = event.composedPath ? event.composedPath() : [event.target];
    return path.some(node => {
      if (!(node instanceof Element)) return false;
      if (node.matches('input, textarea, [contenteditable="true"]')) return false;
      if (node.matches('img, picture, canvas')) return true;
      if (node.matches('a') && node.querySelector('img, picture')) return true;
      return /url\(/.test(getComputedStyle(node).backgroundImage);
    });
  };
  for (const type of ['contextmenu', 'dragstart']) {
    document.addEventListener(type, event => {
      if (isPhoto(event)) event.preventDefault();
    }, { capture: true });
  }
})();
